import vue from 'vue'

// 这里就是我们刚刚创建的那个静态组件
import messageComponent from './message.vue'

// 返回一个 扩展实例构造器
const MessageConstructor = vue.extend(messageComponent)

// 定义弹出组件的函数 接收2个参数, 要显示的文本 和 显示时间
function showMessage(message, isAlert = null) {
    if(!isAlert){
        window.alert(message);
    }else{
        // 实例化一个 message.vue
        const messageDom = new MessageConstructor({
            el: document.createElement('div'),
            data() {
                return {
                    message: message,
                    show: true
                }
            }
        })
        MessageConstructor.prototype.closeMsg = function() {
            let vm = this;
            let promise=new Promise(function(resolve,reject){
                if (vm.$el && vm.$el.parentNode) {
                    vm.$el.parentNode.removeChild(vm.$el);
                }
                resolve();
                vm.$destroy();
                vm.show = false;
            })
            return promise
        };
        document.body.appendChild(messageDom.$el)
    }    
}

// 注册为全局组件的函数
function registryMessage() {
    // 将组件注册到 vue 的 原型链里去,
    // 这样就可以在所有 vue 的实例里面使用 this.$toast()
    vue.prototype.$msg = showMessage
}

export default registryMessage


// WEBPACK FOOTER //
// ./src/components/message/index.js